/* local config
const CLIENT_ID = "0oak560ivkGA88CUV357";
const ISSUER = "https://aristocrat.okta.com/";
const REDIRECT_URI = `${window.location.origin}/login/callback`;

export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: false,
  },
  app: {
    basename: "",
  },
};*/

/*
const CLIENT_ID = process.env.REACT_APP_SSP_OKTA_CLIENTID;
const ISSUER = process.env.REACT_APP_SSP_OKTA_PROVIDER;
const REDIRECT_URI = `${window.location.origin}/login/callback`;

export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: false,
  },
  app: {
    basename: "",
  },
};*/

// src/configuration/oktaconfig.js

const CLIENT_ID = process.env.REACT_APP_SSP_OKTA_CLIENTID;
const ISSUER = process.env.REACT_APP_SSP_OKTA_PROVIDER;
const REDIRECT_URI = `${window.location.origin}/login/callback`;

// Define the configuration object
const oktaConfig = {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email', 'groups'],
    pkce: true,
    disableHttpsCheck: false,
  },
  app: {
    basename: "",
  },
};

// Export the configuration object
export default oktaConfig;
